<template>
	<div class="row text-white">
		<div class="col-12 text-center mb-1 mt-4 mb-2">
			<span class="fs-1-4 bold">Classe</span> <span class="fs-1-4 bold">{{classData.classe}}°</span> <span class="fs-1-4 bold">{{classData.sezione}}</span>
		</div>

		<div class="col-12 mb-2">
			<div class="border-4-blk mx-3 px-2 py-2 text-center bold white-button load-story-btn rounded-pill" role="button" @click.prevent="openFormText(0)">
				<span class="fs-1-1 va-inh">CARICA FRASE</span>
			</div>
		</div>

		<div class="col-12 mb-3">
			<div class="border-4-blk mx-3 px-2 py-2 text-center bold white-button load-story-btn rounded-pill" role="button" @click.prevent="openForm(0)">
				<span class="fs-1-1 va-inh">CARICA STORY</span>
			</div>
		</div>

		<div class="col-12" v-for="(work, index) in workList" :key="index">

			<div class="border-2-fv" :class="{'wrk-editable': (work.active == 0), 'wrk-not-editable': (work.active == 1)}" v-if="work.type == 'video'">
				<div class="row align-items-center px-2 wrk-content">
					<div class="col lh-1-1 py-2 bold"><span class="va-m">{{work.title}}</span></div>
					<div class="col-2 fn-icon border-2-l-fv border-2-r-fv p-0 align-self-stretch align-items-center" v-if="work.active == 0">
						<div class="d-flex align-items-center h-100" title="Modifica story">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil m-auto" viewBox="0 0 16 16" @click.prevent="onEditClick(work.id)">
								<path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
							</svg>
						</div>
					</div>
					<div class="col-2 fn-icon p-0 align-self-stretch" v-if="work.active == 0">
						<div class="d-flex align-items-center h-100 mr-2" title="Elimina story">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash m-auto" viewBox="0 0 16 16" @click.prevent="onDeleteClick(work.id, work.title)">
								<path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
								<path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
							</svg>
						</div>
					</div>
				</div>
			</div>

			<div class="border-2-fv" :class="{'wrk-editable': (work.active == 0), 'wrk-not-editable': (work.active == 1)}" v-else-if="work.type == 'text'">
				<div class="row align-items-center px-2 wrk-content">
					<div class="col lh-1-1 py-2 bold"><span class="va-m">{{work.text}}</span></div>
					<div class="col-2 fn-icon border-2-l-fv border-2-r-fv p-0 align-self-stretch align-items-center" v-if="work.active == 0">
						<div class="d-flex align-items-center h-100" title="Modifica testo">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil m-auto" viewBox="0 0 16 16" @click.prevent="onEditTextClick(work.id)">
								<path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
							</svg>
						</div>
					</div>
					<div class="col-2 fn-icon p-0 align-self-stretch" v-if="work.active == 0">
						<div class="d-flex align-items-center h-100 mr-2" title="Elimina frase">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash m-auto" viewBox="0 0 16 16" @click.prevent="onDeleteTextClick(work.id, work.text)">
								<path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
								<path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
							</svg>
						</div>
					</div>
				</div>
			</div>

		</div>

		<div class="col-12 text-center" v-if="delMsg">
			<small v-html="delMsg"></small>
		</div>

	</div>
</template>

<script>
const jQuery = window.jQuery
import axios from 'axios'

export default {
	name: 'ClassBoxComponent',
	props: ['classData'],

		data() {
			return {
				ajaxObj: window.ajax_object,
				workList: {},
				toDelete: '',
				delMsg: ''
			}
		},

		methods: {
			getWorksdata() {
				let url = this.ajaxObj.ajax_url

				var data = new FormData();
				data.append('action', 'nl_get_class_wrk_data')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('classID', this.classData.id)

				axios.post(url, data)
					.then((response) => {
						// console.log(response.data)
						this.workList = response.data
					}, (error) => {
						console.log(error);
					});
			},

			onDeleteClick(workId, workTitle) {
				this.toDelete = workId
				let modalText = 'Sei sicuro di voler eliminare la story "' + workTitle + '"?'
				this.showAlertDeleteStory('Elimina story', modalText)
			},

			onDeleteTextClick(workId, workTitle) {
				this.toDelete = workId
				let modalText = 'Sei sicuro di voler eliminare la frase "' + workTitle + '"?'
				this.showAlertDeleteText('Elimina frase', modalText)
			},

			onEditClick(workId) {
				this.openForm(workId)
			},

			onEditTextClick(workId) {
				this.openFormText(workId)
			},

			deleteStory() {
				let url = this.ajaxObj.ajax_url
				let self = this

				var data = new FormData();
				data.append('action', 'nl_delete_story')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('to_delete', this.toDelete)

				this.delMsg = 'Eliminazione story in corso...'

				axios.post(url, data)
					.then((response) => {
						//console.log(response.data)
						this.toDelete = ''
						this.delMsg = ''
						self.$emit('refreshList')
					}, (error) => {
						console.log(error);
					});
			},

			deleteText() {
				let url = this.ajaxObj.ajax_url
				let self = this

				var data = new FormData();
				data.append('action', 'nl_delete_story')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('to_delete', this.toDelete)
				data.append('task', 'text')

				this.delMsg = 'Eliminazione frase in corso...'

				axios.post(url, data)
					.then((response) => {
						//console.log(response.data)
						this.toDelete = ''
						this.delMsg = ''
						self.$emit('refreshList')
					}, (error) => {
						console.log(error);
					});
			},

            showAlertDeleteStory(title, msg) {
                this.$modal.show('dialog', {
                    title: title,
                    text: msg,
                    buttons: [
                        {
                            title: 'Annulla',
                            handler: () => {
                                this.$modal.hide('dialog')
                            }
                        },
                        {
                            title: 'Elimina story',
                            handler: () => {
                                this.deleteStory()
								this.$modal.hide('dialog')
                            }
                        },
                    ]
                })
            },

            showAlertDeleteText(title, msg) {
                this.$modal.show('dialog', {
                    title: title,
                    text: msg,
                    buttons: [
                        {
                            title: 'Annulla',
                            handler: () => {
                                this.$modal.hide('dialog')
                            }
                        },
                        {
                            title: 'Elimina frase',
                            handler: () => {
                                this.deleteText()
								this.$modal.hide('dialog')
                            }
                        },
                    ]
                })
            },

			openForm(wrkId) {
				let data = {
					'classId': this.classData.id,
					'sezione': this.classData.sezione,
					'classe': this.classData.classe,
					'workId': wrkId
				}
				this.$emit('openWrkForm', data)
			},

			openFormText(wrkId) {
				let data = {
					'classId': this.classData.id,
					'sezione': this.classData.sezione,
					'classe': this.classData.classe,
					'workId': wrkId
				}
				this.$emit('openWrkFormText', data)
			}
		},

		mounted() {
			this.getWorksdata()
			jQuery('#download_area_privata').removeClass('d-none')
		}
}
</script>
